module.exports = __webpack_public_path__ + "static/media/act-5.9efd53a5.pdf";